<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      line-form
      show-save-button
      unit="计量单位"
      edit-title
      form-label-width="110px"
      id-key="UnitId"
      :data="data"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item
          label="计量单位编码"
          prop="UnitNo"
          :class="isMB ? 'longLabel' : ''"
        >
          <span v-if="Mode == 0" class="detail-span">{{ data.UnitNo }}</span>
          <el-input
            v-else
            v-model="data.UnitNo"
            placeholder="请输入类别编号"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="计量单位名称"
          prop="UnitName"
          :class="isMB ? 'longLabel' : ''"
        >
          <el-input v-model="data.UnitName" placeholder="请输入计量单位名称" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input
            type="number"
            v-int
            v-model="data.Sn"
            style="width: 100px"
          ></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/ba/unit").default,
      code_api: require("@/api/sy/serialCode").default,
      data: {
        UnitGroupId: null,
        UnitId: 0,
        UnitNo: "",
        UnitName: "",
        Status: 1,
        IsGroup: false,
        Sn: null,
      },
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      isMB: this.$store.state.isMB,
      rules: {
        UnitNo: [{ required: true, message: "账号编码不能为空" }],
        UnitName: [{ required: true, message: "账号名称不能为空" }],
        Sn: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    serialCode() {
      this.code_api.previewNo("计量单位").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.UnitNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取存货档案类别编号失败");
        }
      });
    },
    onCreateOpened() {
      this.serialCode();
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
      // this.code_api.previewNo("计量单位").then((res) => {
      //   console.log("serialType", res);
      //   if (res.Code == 0) {
      //     this.Mode = res.Data.Mode;
      //     this.data.UnitNo = res.Data.PreviewNo;
      //   } else {
      //     this.$message.warning("获取计量单位编号失败");
      //   }
      // });
    },
  },
};
</script>
